import React from 'react';

const ListOfFormTable = ({tableData}) => {
  return (
    <div className='table_container iransans'>
      <table>
        <thead>
        <tr>
          <th style={{width: "36px"}}>ردیف</th>
          <th style={{width: "70px"}}>کد فرم</th>
          <th style={{width: "127px"}}>عنوان فرم</th>
          <th style={{width: "70px"}}>ورژن</th>
          <th style={{width: "70px"}}>نسخه ورژن</th>
          <th style={{width: "70px"}}>کد فرم نیاز</th>
          <th style={{width: "120px"}}>عنوان فرم نیاز</th>
        </tr>
        </thead>
        <tbody>
        {tableData
          ? tableData.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item.formId}</td>
              <td>{item.title}</td>
              <td>{item.version}</td>
              <td>-</td>
              <td>-</td>
              <td>{item.formTitle}</td>
            </tr>
          ))
          : null}
        </tbody>
      </table>
    </div>
  );
};

export default ListOfFormTable;